import { Api } from "../helpers";

export const apTemplateService = {
  getById,
  updateAPT,
  createAPT,
  getAll,
  updateQuestionPivot,
  removeQuestionFromPivot
};

// get the ap by his id
function getById(id) {
  return Api()
    .get("/accept-protocol-template/" + id)
    .then(response => {
      // return accept-protocol-template by id
      // {"data":{"id":1,"name":"Virtual PBX","language_id":1,"version":1,"enabled":1,..}
      return response.data.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// update existing  APT, pass data
// {APQuestion_id: 2,APTemplate_id: 1,position: 1,region_id: 2}
function updateAPT(options) {
  return Api()
    .put("/accept-protocol-template/" + options.id, options.data)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      return response.data.data;
    })
    .catch(err => {
      console.log("error:", err);
      return Promise.reject(err);
    });
}

// create new APT, pass data
function createAPT(options) {
  return Api()
    .post("/accept-protocol-template", options.data)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}      
      return response.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}


// get all ap-templates by language ID (language_id = )
function getAll(options) {
  return Api()
    .get("/accept-protocol-templates/all", {
      params: options
    })
    .then(response => {
      // return all protocol templates
      // [{id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1, …}, {…}]      
      return response.data.data;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}

// update quedtion pivot table
// new qeustion has been added to the template
function updateQuestionPivot(options) {
  return Api()
    .post("/accept-protocol-template-question/" + options.id, options.data)
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      return response.data.data;
    })
    .catch(err => {
      console.log("error:", err);
      return Promise.reject(err);
    });
}

// remove question from pivot table
function removeQuestionFromPivot(options) {
  return Api()
    .delete("/accept-protocol-template-question/" + options.id, { data: options.data })
    .then(response => {
      // return accept-protocol by id
      // {id: 1, name: "Virtual PBX", language_id: 1, version: 1, enabled: 1,…}
      return response.data.data;
    })
    .catch(err => {
      console.log("error:", err);
      return Promise.reject(err);
    });
}

